import React, { FormEvent, useCallback, useState, useEffect } from 'react'
import { BsFillTrashFill, BsThreeDotsVertical } from 'react-icons/bs'
import { FiEdit3 } from 'react-icons/fi'
import useApi from '../../hooks/useApi'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import Modal from '../../Korbantech/components/Modal'
import { LibraryItem } from '../../types/LibraryItem'
import { ContextMenu } from '../ContextMenu'
import { LibraryForm } from './LibraryForm'

export const LibraryCard = ({ item, type }: Props) => {

    const [contextIsOpen, setContextIsOpen] = useState<boolean>()
    const [modal, setModalOpen] = useState<boolean>(false)
    const [modalDelete, setModalDeleteOpen] = useState<boolean>(false)
    const [valueBtn, setValueBtn] = useState<string>()
    const api = useApi()

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        data.append('_method', 'PATCH')
        return await api.post(`/admin/library/${type}/${item.id}`, data).then(res => {
            window.location.reload()
        }).catch(console.log)

    }, [api, type, item])

    const handleDelete = useCallback(async () => {
        await api.delete(`/admin/library/${type}/${item.id}`).then(res => {
            window.location.reload()
        }).catch(console.log)
    }, [api, item, type])


    useEffect(() => {

        switch (type) {
            case 'videos':
                setValueBtn('Atualizar videos');
                break;

            case 'ebooks':
                setValueBtn('Atualizar ebook');
                break;

            case 'hints':
                setValueBtn('Atualizar dicas');
                break;

            case 'materials':
                setValueBtn('Atualizar material');
                break;

            default:
                break;
        }

    }, [type])


    return (
        <div className='bg-white flex flex-col justify-center rounded-lg  relative'>
            {item.image ?
                <img className='h-40' style={{ width: "auto" }} src={item.image} alt={item.title} /> : <img className='h-40' style={{ width: "auto" }} src={"https://via.placeholder.com/237x129"}
                    alt={item.title}
                />}
            <div className='p-1'>
                {item.title &&
                    <div className='flex justify-between'>
                        <div className='text-lg font-semibold'>{item.title}</div>
                        <div>
                            <BsThreeDotsVertical className='text-lg' onClick={() => setContextIsOpen(true)} />
                            <div className='relative'>
                                <ContextMenu open={contextIsOpen} close={() => setContextIsOpen(false)}>
                                    <div className='flex items-center cursor-pointer' onClick={() => setModalOpen(true)}>
                                        <FiEdit3 className='mr-1' />Editar
                                    </div>
                                    <div className='flex items-center cursor-pointer' onClick={() => setModalDeleteOpen(true)}>
                                        <BsFillTrashFill className='mr-1 text-red-500' />Deletar</div>
                                </ContextMenu>
                            </div>
                        </div>
                    </div>
                }
                {type === "videos" &&
                    <div className='flex justify-between'>
                        <div className='text-lg'>link: {item.link}</div>
                        <div>
                            <BsThreeDotsVertical className='text-lg' onClick={() => setContextIsOpen(true)} />
                            <div className='relative'>
                                <ContextMenu open={contextIsOpen} close={() => setContextIsOpen(false)}>
                                    <div className='flex items-center cursor-pointer' onClick={() => setModalOpen(true)}>
                                        <FiEdit3 className='mr-1' />Editar
                                    </div>
                                    <div className='flex items-center cursor-pointer' onClick={() => setModalDeleteOpen(true)}>
                                        <BsFillTrashFill className='mr-1 text-red-500' />Deletar</div>
                                </ContextMenu>
                            </div>
                        </div>
                    </div>
                }
                {item.description &&
                    <div className='text-gray-600 text-sm'>
                        {item.description.slice(0, 120)}
                    </div>
                }
            </div>
            <Modal open={modal} onClickCloseButton={() => setModalOpen(false)}>
                <form onSubmit={handleSubmit}>

                    {type === "videos" && <LibraryForm title="Nome" link="Link do vídeo" image={"Thumbnail"} />}
                    {type === "ebooks" && <LibraryForm title={"Título"} image={"Imagem do card"}
                        pdf={"Ebook (pdf)"} description={"Descrição"} link="Link" />}
                    {type === "hints" && <LibraryForm title={"Título"} image={"Imagem do card"}
                        description={"Descrição"} link="Link" />}
                    {type === "materials" && <LibraryForm title={"Título"} image={"Imagem do card"}
                        pdf={"Template"} description={"Descrição"} link="Link" />}

                    <div className='col-span-3 px-6 mb-3'>
                        <SubmitButton value={valueBtn} />
                    </div>
                </form>
            </Modal>
            <Modal open={modalDelete} onClickCloseButton={() => setModalDeleteOpen(false)}>
                <div className='flex flex-col p-2'>
                    <strong>Deseja mesmo deletar o item :</strong>
                    {item.title}
                    <div className='flex justify-between gap-x-2'>
                        <button className='bg-primary-dark mt-3 py-1 px-2 rounded-md' onClick={() => setModalOpen(false)}>
                            Cancelar
                        </button>
                        <button className='bg-red-500 mt-3 py-1 px-2 rounded-md text-white' onClick={() => handleDelete()}>
                            Confirmar e deletar
                        </button>
                    </div>


                </div>
            </Modal>
        </div>
    )
}

interface Props {
    item: LibraryItem
    type: string
}